<template>
  <div class="d-flex justify-space-between align-center footer">
    <img
      src="../../../assets/mobile/icon/home.svg"
      width="20"
      height="20"
      @click="$router.push({ name: 'CommunityMobile' })"
    />
    <img
      src="../../../assets/mobile/icon/search.svg"
      width="20"
      height="20"
      @click="$router.push({ name: 'DiscoverMobile' })"
    />
    <img
      src="../../../assets/mobile/icon/trending.svg"
      width="20"
      height="20"
      @click="$router.push({ name: 'SpotlightMobile' })"
    />
    <img
      src="../../../assets/mobile/icon/chat.svg"
      width="20"
      height="20"
      @click="$router.push({ name: 'NotificationMobile' })"
    />
    <img
      src="../../../assets/mobile/user.svg"
      width="20"
      height="20"
      @click="$router.push({ name: 'YouMobile' })"
    />
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  position: fixed;
  z-index: 5;
  bottom: 0px;
  width: 100%;
  left: 0px;
  height: 81px;
}
</style>



// WEBPACK FOOTER //
// footer.vue?9d68d676